import { Store } from 'redux';

class StateService {
  private static store: Store;

  public static injectStore = (store: Store) => (StateService.store = store);

  public static readonly getAccessToken = (): string | undefined =>
    StateService.store.getState().auth.authToken?.access_token;
}

export { StateService };
